<div class="flex items-center gap-1 bg-green-regular rounded-sm px-1 mt-2">
  <i class="fa-solid fa-circle-check text-[8px]"></i>
  <app-typography
    variant="p-sm-dark"
    class="!text-[10px] text-green-light">
      {{ 'LABEL.VERIFIED' | translate }}
  </app-typography>
</div>
